import { render, staticRenderFns } from "./despesas.vue?vue&type=template&id=06afbbc8&scoped=true&"
import script from "./despesas.vue?vue&type=script&lang=js&"
export * from "./despesas.vue?vue&type=script&lang=js&"
import style0 from "./despesas.vue?vue&type=style&index=0&id=06afbbc8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06afbbc8",
  null
  
)

export default component.exports